module.exports = __webpack_public_path__ + "static/illustration-dont-c366fb14829eb14c02a3f2d3ddd5ee36.png";